export default "__VITE_ASSET__31de8e2c__"